/* VIDA - Buscador: panel accesible con resultados en vivo (API publica /search/suggest.json de Shopify) */
(function () {
  'use strict';
  var panel = document.querySelector('[data-search]');
  if (!panel) return;
  var input = panel.querySelector('[data-search-input]');
  var form = panel.querySelector('[data-search-form]');
  var suggest = panel.querySelector('[data-search-suggest]');
  var live = panel.querySelector('[data-search-live]');
  var lastOpener = null, hideTimer, debounce, ctrl;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = new Intl.NumberFormat('es-CL', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP', maximumFractionDigits: 0 });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function open(opener) {
    lastOpener = opener || null;
    clearTimeout(hideTimer);
    panel.hidden = false;
    document.body.classList.add('v-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); input.focus({ preventScroll: true }); }); });
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function close() {
    panel.classList.remove('is-open');
    document.body.classList.remove('v-lock');
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    hideTimer = setTimeout(function () { panel.hidden = true; }, 700);
    if (lastOpener && document.contains(lastOpener) && lastOpener.offsetParent !== null) lastOpener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-search-open]');
    if (o) {
      e.preventDefault();
      if (o.hasAttribute('data-from-drawer')) document.dispatchEvent(new Event('vida:close-drawer'));
      open(o.hasAttribute('data-from-drawer') ? null : o);
      return;
    }
    if (e.target.closest('[data-search-close]')) { close(); return; }
    if (panel.classList.contains('is-open') && e.target === panel) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!panel.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') { // trampa de foco
      var f = panel.querySelectorAll('input, button, a[href]');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') ) {
      var items = Array.prototype.slice.call(panel.querySelectorAll('.v-search__item:not([hidden])')).filter(function (x) { return x.offsetParent !== null; });
      if (!items.length) return;
      var idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[idx < 0 ? 0 : Math.min(items.length - 1, idx + 1)].focus(); }
      else if (idx > 0) { e.preventDefault(); items[idx - 1].focus(); } else if (idx === 0) { e.preventDefault(); input.focus(); }
    }
  });

  // Atajo: "/" abre el buscador cuando no se esta escribiendo
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || panel.classList.contains('is-open')) return;
    var t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    e.preventDefault(); open(null);
  });

  function render(q, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], collections = res.collections || [];
    var html = '';
    if (products.length) {
      html += '<p class="v-caption v-caption--caps">Productos</p><ul class="v-search__results" role="list">';
      products.forEach(function (p) {
        var price = p.price ? money.format(parseFloat(p.price)) : '';
        html += '<li><a class="v-search__item" href="' + esc(p.url) + '"><span class="v-search__thumb v-media">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="80" height="80" loading="lazy">' : '') +
          '</span><span class="v-search__info"><b>' + esc(p.title) + '</b><small>' + esc(price) + (p.available === false ? ' · Agotado' : '') + '</small></span>' +
          '<svg class="v-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6"/></svg></a></li>';
      });
      html += '</ul>';
    }
    if (collections.length) {
      html += '<p class="v-caption v-caption--caps">Colecciones</p><ul class="v-search__chips" role="list">';
      collections.forEach(function (c) { html += '<li><a class="v-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; });
      html += '</ul>';
    }
    if (!products.length && !collections.length) {
      html = '<div class="v-search__empty"><p class="v-h3">Sin resultados para «' + esc(q) + '»</p><p class="v-text">Revisa la ortografía o prueba con otra palabra. También puedes hacer el quiz y te recomendamos un producto.</p><a class="v-btn v-btn--ghost v-btn--sm" href="/pages/quiz">Hacer el quiz</a></div>';
    } else {
      html += '<a class="v-link v-search__more" href="' + root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(q) + '&type=product">Ver todos los resultados <svg class="v-icon v-icon--arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6"/></svg></a>';
    }
    live.innerHTML = html;
  }

  function search(q) {
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    live.hidden = false; suggest.hidden = true;
    live.innerHTML = '<div class="v-search__loading" role="status" aria-label="Buscando"></div>';
    var url = root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) { render(q, d); })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        live.innerHTML = '<div class="v-search__empty"><p class="v-text">No pudimos buscar ahora. Intenta de nuevo o <a href="' + root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(q) + '">mira los resultados completos</a>.</p></div>';
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounce);
    var q = input.value.trim();
    if (q.length < 2) { if (ctrl) ctrl.abort(); live.hidden = true; live.innerHTML = ''; suggest.hidden = false; return; }
    debounce = setTimeout(function () { search(q); }, 220);
  });
  form.addEventListener('submit', function (e) { if (input.value.trim().length < 1) e.preventDefault(); });

  window.VidaSearch = { open: open, close: close };
})();
